import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];
  static values = {
    filterable: Boolean,
  };

  connect() {
    this.items = [];
    this._buildInitialItems();
    this._renderItems(this.items);
  }

  addItemElement(element) {
    const id = element.dataset.id;
    const name = element.dataset.name;
    if (id && name && !this.items.some((item) => item.id === id)) {
      this.items.push({ id, name, element });
      this._sortItems();
      const parentController =
        this.application.getControllerForElementAndIdentifier(
          this.element.closest(
            '[data-controller~="user-tag-subscriptions--tag-subscription-section"]'
          ),
          "user-tag-subscriptions--tag-subscription-section"
        );
      const searchText = parentController?.searchInputTarget.value || "";
      this.filter(searchText);
    }
  }

  removeItemElement(element) {
    const idToRemove = element.dataset.id;
    this.items = this.items.filter((item) => item.id !== idToRemove);
    this._updateEmptyContainerMessage();
  }

  filter(searchText) {
    this._renderItems(this.items, searchText);
  }

  _buildInitialItems() {
    this.itemTargets.forEach((element) => {
      const id = element.dataset.id;
      const name = element.dataset.name;
      if (id && name) {
        this.items.push({ id, name, element });
      }
    });
    this._sortItems();
  }

  _sortItems() {
    this.items.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  _escapeRegExp(string) {
    // $& means the whole matched string
    return string.replace(/[.*+?^${}()|[\\\]]/g, "\\$&");
  }

  _renderItems(itemsToRender, searchText = "") {
    let wordBoundaryRegex = null;
    const escapedSearchText = this._escapeRegExp(searchText);

    if (this.filterableValue && searchText) {
      // Capture the matched text for highlighting
      wordBoundaryRegex = new RegExp(`\\b(${escapedSearchText})`, "i");
    }

    // Hide all items
    this.items.forEach((item) => {
      if (item.element) {
        item.element.style.display = "none";
      }
    });

    let visibleCount = 0;
    itemsToRender.forEach((item) => {
      const matchesFilter =
        !wordBoundaryRegex || wordBoundaryRegex.test(item.name);

      if (matchesFilter && item.element) {
        // Show the element
        item.element.style.display = "";
        visibleCount++;

        // Update the text content for highlighting
        const labelSpan = item.element.querySelector(".checkbox-text");
        if (labelSpan) {
          if (wordBoundaryRegex) {
            // Use innerHTML to allow bold tag, replace first match
            labelSpan.innerHTML = item.name.replace(
              wordBoundaryRegex,
              "<strong>$1</strong>"
            );
          } else {
            // No filter active, just set text content
            labelSpan.textContent = item.name;
          }
        }
      }
    });

    this._updateEmptyContainerMessage(searchText, visibleCount);
  }

  _updateEmptyContainerMessage(searchText = "", renderedItemCount = 0) {
    // Remove any existing "No matches found" message
    const existingMessage = this.element.querySelector(".no-matches-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    // Display "No matches found" only if filtering is active, yielded no results.
    if (this.filterableValue && searchText && renderedItemCount === 0) {
      const message = document.createElement("div");
      message.classList.add("well", "well-sm", "text-muted", "text-center", "no-matches-message");
      message.textContent = "No matches found";
      this.element.appendChild(message);
    }
  }
}
